export const selectCurrentImg = (state) => state.game.currentImg;
export const selectCounterValue = (state) => state.game.movesCounter;
export const selectGameState = (state) => state.game.gameState;
export const selectShowingArray = (state) => state.game.showingArray;
export const selectUnshuffledImages = (state) => state.game.unshuffledImages;
export const selectImagesState = (state) => state.game.imagesState;
export const selectIdOfSelected = (state) => state.game.idOfSelected;
export const selectMatchedImages = (state) => state.game.matchedImages;
export const selectLevelStar = (state) => state.game.star;

